import { action, makeAutoObservable } from 'mobx';
import { Entity } from '../models/Entity';
import { Rule } from '../models/Rule';

export class EntitiesStore {
  entities: Map<number, Entity> = new Map();
  loadingRules: number[] = [];
  oldRules: Rule[] = [];
  ruleApptIdMap: Map<number, Rule> = new Map();
  ruleApptIdMapBuilt: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  addEntity = action((entity: Entity) => {
    this.entities.set(entity.id, entity);
  });

  get = (entityId: number): Entity => this.entities.get(entityId);

  nameFor = (entityId: number): string => {
    const entity = this.get(entityId);

    return entity ? entity.name : '';
  };

  get entitiesMap(): Map<number, string> {
    return new Map(
      [...this.entities.keys()].map(entityId => [
        entityId,
        this.nameFor(entityId),
      ])
    );
  }
}
